export default "__VITE_ASSET__BnM$mR29__"